import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import filter from 'lodash/filter';
import get from 'lodash/get';
import shuffle from 'lodash/shuffle';
import values from 'lodash/values';
import uniq from 'lodash/uniq';
import times from 'lodash/times';
import Color from 'color';
import { Motion } from 'react-motion';
import { EMPTY_ARRAY, EMPTY_OBJECT, RESPONSIVE_SIZE } from '../../constants';
import { imageColors } from '../../lib/Color';
import { springify } from '../../lib/Motion';
import { buildSearchParams, search } from '../../actions/search';
import ImageLoader from '../ImageLoader';
import Style from '../Style';

const cellSizeMultiplyer = 0.5;
const cellWidth = 25 * cellSizeMultiplyer;
const cellHeight = 14 * cellSizeMultiplyer;
const cellMargin = 0.2 * cellSizeMultiplyer;
const cellsOverflow = 3;
const scale = 2;

class HowItWorksGrid extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    getClips: PropTypes.func,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      rowCount: 8,
      clips: EMPTY_ARRAY,
    };

    this.loadClips();
  }

  loadClips = () => {
    return this.props.getClips().then(clips =>
      this.setState({
        clips: shuffle(clips),
      }),
    );
  };

  render() {
    const columnCount =
      Math.ceil(this.props.responsive / (cellWidth * 10)) + cellsOverflow * 2;
    const available = this.state.clips.length;

    return (
      <div
        style={{
          perspective: '260rem',
          transformStyle: 'preserve-3d',
        }}
      >
        <div
          style={{
            transform: `rotateX(68deg) rotateY(4deg) rotateZ(15deg) scale(${scale}) translateX(-${cellsOverflow *
              cellWidth /
              (scale * 2)}rem)`,
            transformOrigin: 'center center',
            width: `${columnCount * (cellMargin + cellWidth)}rem`,
          }}
        >
          {times(this.state.rowCount, rowIndex => (
            <div
              key={`row ${rowIndex}`}
              style={{
                display: 'flex',
                width: `${columnCount * (cellMargin + cellWidth)}rem`,
              }}
            >
              {times(columnCount, columnIndex => {
                let clip = EMPTY_OBJECT;
                let opacity = Math.random() * 0.4 + 0.3;
                if (available > 0) {
                  const index =
                    (rowIndex * columnCount + columnIndex) % available;
                  clip = this.state.clips[index];
                  // opacity = 1;
                }

                return (
                  <div
                    key={`row ${rowIndex} column ${columnIndex}`}
                    style={{
                      transform: 'translate3d(0,0,0)',
                      position: 'relative',
                      flex: `0 0 ${cellWidth}rem`,
                      width: `${cellWidth}rem`,
                      height: `${cellHeight}rem`,
                      margin: `${cellMargin}rem`,
                      boxShadow: `1.8rem 9rem 1rem 0 ${Color('#283036').alpha(
                        0.2,
                      )}`,
                    }}
                  >
                    <ImageLoader
                      color={Color(
                        imageColors(clip.clip_colors || EMPTY_OBJECT).dark,
                      ).alpha(opacity)}
                      lqip={clip.clip_lqip}
                      images={[clip.clip_thumbnail]}
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClips: () =>
      dispatch(search(buildSearchParams('', [900]))).then(
        results => results.clips,
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HowItWorksGrid);



// WEBPACK FOOTER //
// ./src/components/HowItWorksGrid/HowItWorksGrid.js